import { render, staticRenderFns } from "./WritingData.vue?vue&type=template&id=061cebd1&scoped=true"
import script from "./WritingData.vue?vue&type=script&lang=ts"
export * from "./WritingData.vue?vue&type=script&lang=ts"
import style0 from "./WritingData.vue?vue&type=style&index=0&id=061cebd1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061cebd1",
  null
  
)

export default component.exports